export const removeReloadSuffix = (exchangeToken: string) => {
  if (exchangeToken.includes('_reload')) {
    return exchangeToken.replaceAll(/_reload\d*/g, '');
  }
  return exchangeToken;
};
